import axios from "axios"

function getIntercomIdentityToken() {
    return axios.post("api/v1/family/intercom-identity-token")
}

export const familyService = {
    getIntercomIdentityToken,
}
